//components
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { Alert } from 'reactstrap';
import Spinner from "../Spinner/Spinner";
import OtpVerificationAction from "./OtpVerificationAction";

//libraries / actions/ constants/ utils
import { Strings } from "../../Resources/Strings/i18n";
import { PATHS } from "./../../Constants";
import { OperationStatus, APIResponse } from "../../Communication/Constants";
import { LoginAction } from "../Login/LoginAction";
import DashBordAction from "../Dashboard/DashboardAction";

class OtpVerification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            spinner: false,
            show: this.props.showVerifyModal,
            otpEntered: "",
            fetchedUserData: "",
            showDashboard: false,
            userid: "-1",
            otpResentSuccessMessageOpen: false,
            errorMessage: "",
            errorCase: false,
        };
        this.LoginAction = new LoginAction();
        this.verifyOTP = new OtpVerificationAction();
        this.DashBordAction = new DashBordAction();
    }
    componentDidMount() {
        this.OtpInput.focus();
    }

    componentDidUpdate() {
        if (
            this.state.errorCase || this.state.otpResentSuccessMessageOpen) {
            this.hideTimeout = setTimeout(
                () =>
                    this.setState({
                        otpResentSuccessMessageOpen: false,
                        errorCase: false,
                    }),
                5000
            );
        }
    }
    componentWillUnmount() {
        clearTimeout(this.hideTimeout);
    }

    showModal = () => {
        this.setState({ show: true });
    };
    hideModal = () => {
        this.setState({ show: false });
    };
    isValidNumber(mobileNumber) {
        return /^\d+$/.test(mobileNumber);
    }
    handleChange = (event) => {
        let otpText = String(event.target.value);

        if (
            (this.isValidNumber(otpText) && otpText.length < 4) ||
            otpText.length === 0
        ) {
            this.setState({
                otpEntered: otpText,
            });
        }
    };
    setCursorPosition = (event) => {
        event.target.setSelectionRange(
            event.target.value.length,
            event.target.value.length
        );
    };
    enterPress_Login = (event) => {
        if (event.charCode === 13) {
            this.proceedToDashboard();
        }
    };
    proceedToDashboard = () => {
        if (this.state.otpEntered.length === 3) {
            //
            let requestBody = {};
            if (this.props.countryCallingCode && this.props.mobileNumber) {
                requestBody = {
                    mobile: this.props.mobileNumber,
                    calling_code: this.props.countryCallingCode,
                    otp: this.state.otpEntered,
                    device_type: 3,
                    user_agent: "web",
                }
            }
            
            if (this.props.email) {
                requestBody = {
                    email: this.props.email,
                    otp: this.state.otpEntered,
                    device_type: 3,
                    user_agent: "web"
                }
            }

            this.verifyOTP.verifyOTP(
                requestBody,
                (actionCallback) => {
                    if (actionCallback.status === OperationStatus.SUCCESS) {
                        let loggedInUserData = JSON.stringify(
                            actionCallback.data,
                            null,
                            2
                        );
                        this.setState({
                            userid: actionCallback.data.data.id,
                            fetchedUserData: loggedInUserData,
                            showDashboard: true,
                            showModal: false,
                            errorMessage: "",
                        });
                        this.props.history.push(PATHS.HOME);
                    }
                      else {
                        this.setState({
                            errorCase: true,
                            errorMessage: actionCallback.error.errorMessage,
                            otpEntered: "",
                            showModal: false,
                        });
                    }
                }
            );
        } else {
            if (this.state.otpEntered.length === 0) {
                this.setState({
                    errorCase: true,
                    errorMessage: Strings("OTPCannotBeBlank"),
                });
            } else {
                this.setState({
                    errorCase: true,
                    errorMessage: Strings("InvalidOTPEntered"),
                    otpEntered: "",
                });
            }
        }
    };

    resendOtp = () => {
        this.setState({ otpEntered: "" });
        this.setState({ showModal: true });
        this.LoginAction.loginAction(
            {
                mobile: this.props.mobileNumber,
                calling_code: this.props.countryCallingCode,
            },
            (actionCallback) => {
                if (actionCallback.status === OperationStatus.SUCCESS) {
                    //On success -> navigate to Verify OTP Pop-Up

                    this.setState({
                        otpResentSuccessMessageOpen: true,
                        showModal: false,
                    });
                } //error handling
                else {
                    //
                    if (
                        actionCallback.error.errorCode ===
                        APIResponse.ACCOUNT_ALREADY_REGISTERED ||
                        actionCallback.error.errorCode ===
                        APIResponse.ACCOUNT_ALREADY_EXIST
                    ) {
                        this.setState({
                            otpResentSuccessMessageOpen: true,
                            showModal: false,
                            errorMessage: actionCallback.error.errorMessage,
                        });
                    } else {
                        this.setState({
                            otpResentFailedMessageOpen: true,
                            errorCase: true,
                            errorMessage: actionCallback.error.errorMessage,
                            showModal: false,
                        });
                    }
                }
            }
        );
    };
    renderAlert = () => {
        return (
            <Alert color="danger" className="alertMessage">
                {this.state.errorMessage}
            </Alert>
        );
    };
    render() {
        return (
            <div className="">
                <Spinner showModal={this.state.showModal} />{" "}
                <div className="verifyOtp">
                    <div className="verifyModal">
                        <br />
                        <div className="modalTitle">
                            <p id="verifyTitle">
                                <span id="verifiText">{Strings("Verifi")}</span>
                                {Strings("cation")}
                            </p>
                        </div>
                        {this.state.errorCase ? this.renderAlert() : null}
                        {this.state.otpResentSuccessMessageOpen ? (
                            <Alert color="success" className="alertMessage">
                                {Strings("OTPResentSuccessFully")}
                            </Alert>
                        ) : null}
                        <p className="infoText">{(this.props.countryCallingCode && this.props.mobileNumber) ? Strings("OTPInfoText") : Strings("OTPInfoEmailText")}</p>
                        <br />
                        <div className="otpInputContainer">
                            <div className="otpInput">
                                <input
                                    ref={(input) => {
                                        this.OtpInput = input;
                                    }}
                                    className="otpInputText"
                                    type="text"
                                    maxLength="3"
                                    value={this.state.otpEntered}
                                    onKeyPress={this.enterPress_Login}
                                    onClick={this.setCursorPosition}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                        <br />
                        <p className="infoText">
                            Sent to (
                                {
                                (this.props.countryCallingCode && this.props.mobileNumber) ? 
                                <>
                                 <span id="phoneNoText">
                                    {this.props.countryCallingCode} -{" "}
                                    {this.props.mobileNumber}
                                </span>
                                </>
                                :
                                (this.props.email) &&
                                <>
                                <span id="phoneNoText">
                                    {this.props.email}
                                </span>
                                </>
                                }
                           
                            )
                        </p>
                        <br />
                        <Button
                            className="verifyBtn"
                            onClick={this.proceedToDashboard}
                        >
                            {Strings("VERIFY")}
                        </Button>
                        <p className="infoText">{Strings("codeNotReceived1")}</p>
                        <Button
                             className="resendBtn"
                            onClick={this.resendOtp}
                        >
                            {Strings("resend")}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        currentUserInfo: state.currentUserInfo,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

OtpVerification.defaultProps = {
    showVerifyModal: false,
    mobileNumber: "",
    countryCallingCode: "",
    email: "",
};

export default withRouter(
    connect(mapStateToProps, matchDispatchToProps)(OtpVerification)
);
